import type { IntlShape } from 'react-intl';
import type { SubscriptionFeature } from '@alltrails/types/SubscriptionFeature';
import advancedMapLayersSrc from './images/advanced-map-layers-thumb.avif';

// https://www.figma.com/design/vV97hwFyKhekbcMy2TuNyz/Feature-Merchandising?node-id=840-95326&t=XlR2wnwWYYfdIIZ3-4
const advancedMapLayers = (intl: IntlShape): SubscriptionFeature => ({
  headline: intl.formatMessage({ defaultMessage: 'Advanced Map Overlays' }),
  subheadline: intl.formatMessage({ defaultMessage: 'Understand the land and terrain before you head out' }),
  thumbnailImage: advancedMapLayersSrc.src
});

export default advancedMapLayers;
